import { str } from "@lit/localize";
//#region src/generated/locales/de.ts
var templates = {
	"pd.form.field.required": `Eingabe erforderlich`,
	"pd.form.field.selectRequired": `Eingabe erforderlich`,
	"pd.form.field.checkRequired": `Eingabe erforderlich`,
	"pd.form.field.rangeRequired": `Eingabe erforderlich`,
	"pd.form.field.invalid.mail": `Format mail@test.de verwenden`,
	"pd.form.field.invalid.phone": `Format +49123 123456 verwenden`,
	"pd.form.field.invalid.vat": `Format DE0123456789 verwenden`,
	"pd.form.field.invalid.url": `Gültige URL eingeben (z. B. example.com)`,
	"pd.form.field.invalid.number": `Nur Zahlen erlaubt`,
	"pd.form.required.valid": `* Felder ausgefüllt`,
	"pd.form.required.missing": `* Pflichtfeld fehlt oder fehlerhaft`,
	"s8a355eeb33f58c5f": str`Mindestens ${0} Zeichen`,
	"s512f37f2dba563ec": str`Maximal ${0} Zeichen`,
	"pd.input.password.hide": `Passwort verbergen`,
	"pd.input.password.show": `Passwort anzeigen`,
	"pd.generic-form.no-data": `Keine Daten vorhanden`,
	"pd.generic-form.yes": `Ja`,
	"pd.generic-form.no": `Nein`,
	"pd.generic-form.unknown": `Unbekannt`,
	"pd.suggestion.box.load.data": `Daten werden geladen`,
	"pd.suggestion.box.error.txt": `Technischer Fehler bei der Suche`,
	"pd.suggestion.box.add.new": str`"${0}" neu anlegen`
};
//#endregion
export { templates };
